export default {
    projectName: process.env.REACT_APP_PROJECT_NAME,
    isDev: process.env.NODE_ENV === 'development',
    useReactotron: process.env.NODE_ENV === 'development',
    useServiceWorker: process.env.REACT_APP_USE_SERVICE_WORKER === 'true',
    api: {
        url: process.env.REACT_APP_SOCKET_URL,
        username: process.env.REACT_APP_SOCKET_USERNAME,
        password: process.env.REACT_APP_SOCKET_PASSWORD
    },
    router: {
        useHash: process.env.REACT_APP_ROUTER_USE_MEMORY === 'true'
    },
    reduxPersist: {
        prefix: process.env.REACT_APP_PERSIST_PREFIX + process.env.REACT_APP_PERSIST_VERSION,
        whitelist: ['auth', 'phaseInfo', 'phase', 'mc', 'superadmin']
    }
}



// WEBPACK FOOTER //
// src/config/index.js